import { all, put, takeLatest, call, select } from 'redux-saga/effects';

import { Api } from '$api';
import router from '$navigation/router';
import { exploreActions, exploreSelector } from '$store/explore/index';
import { batchActions } from '$store';
import { postsActions } from '$store/posts';
import { mainActions } from '$store/main';

function* loadExploreWorker() {
  try {
    const query = router.getState().params?.tag ?? '';
    const resp = yield call(Api.post, '/explore', {
      query: query.trim(),
    });
    yield put(
      batchActions(
        exploreActions.setExplore({
          tags: resp.tags,
          posts: resp.posts.map((post) => post.id),
          nextFrom: resp.nextFrom,
        }),
        postsActions.setPosts(resp.posts),
        mainActions.setUsers(resp.users),
        mainActions.setGroups(resp.groups),
      ),
    );
  } catch (e) {
    yield put(exploreActions.setFailed());
  }
}

function* exploreLoadMoreWorker() {
  try {
    const { nextFrom } = yield select(exploreSelector);
    const query = router.getState().params?.tag ?? '';
    const resp = yield call(Api.post, '/explore', {
      query: query.trim(),
      startFrom: +nextFrom,
    });
    yield put(
      batchActions(
        exploreActions.setExploreMore({
          tags: resp.tags,
          posts: resp.posts.map((post) => post.id),
          nextFrom: resp.nextFrom,
        }),
        postsActions.setPosts(resp.posts),
        mainActions.setUsers(resp.users),
        mainActions.setGroups(resp.groups),
      ),
    );
  } catch (e) {
    yield put(exploreActions.setExploreMoreFailed());
  }
}

export function* exploreSaga() {
  yield all([
    takeLatest(exploreActions.loadExplore, loadExploreWorker),
    takeLatest(exploreActions.exploreLoadMore, exploreLoadMoreWorker)
  ]);
}
